import _uniqueId from "lodash/uniqueId";
import React from "react";

import { SidebarListItem, SidebarSublist, SidebarSublistItem } from "../index";
import { toTitleCase } from "../../../../utils/filters";

const SidebarCollapsibleListItem = (props) => {
  const { accordionId, subListItems, title, uid } = props;

  let UID = _uniqueId("SidebarCollapsibleItem-");

  return (
    <div className="SidebarCollapsibleListItem">
      <button
        className="SidebarCollapsibleListItem__toggle"
        data-target={`.${uid}`}
        data-toggle="collapse"
      >
        <SidebarListItem title={toTitleCase(title)} />
      </button>
      <div className={`collapse ${uid}`} data-parent={"#" + accordionId} id={uid}>
        <SidebarSublist>
          {subListItems.map((item) => {
            const scrollTargetId = item.title.replace(/\s+/g, "-").toLowerCase();

            return (
              <span
                className="SidebarCollapsibleListItem__scroll-target d-block cursor"
                data-scroll-target={scrollTargetId}
                key={scrollTargetId}
              >
                <SidebarSublistItem title={toTitleCase(item.title)} />
              </span>
            );
          })}
        </SidebarSublist>
      </div>
    </div>
  );
};

export default SidebarCollapsibleListItem;
